import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import CleaningHero from '../components/CleaningLanding/CleaningHero'
import SocialProof from '../components/CleaningLanding/SocialProof'
import CampaignStrategy from '../components/CleaningLanding/CampaignStrategy'
import WhyOLM from '../components/CleaningLanding/WhyOLM'
import HowItWorks from '../components/CleaningLanding/HowItWorks'
import FAQ from '../components/CleaningLanding/FAQ'
import BookingSection from '../components/CleaningLanding/BookingSection'
import Footer from '../components/Footer'

export default function Cleaning({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <CleaningHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .cleaning-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .cleaning-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .cleaning-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/cleaning')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
